/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentActionConfirmRequest {
    getFixupPrototypeFunction() { return AgentActionConfirmRequest.fixupPrototype; }

    static newInstance(model: Partial<AgentActionConfirmRequest>): AgentActionConfirmRequest {
        let obj = Object.assign(new AgentActionConfirmRequest(), model);
        AgentActionConfirmRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentActionConfirmRequest>): AgentActionConfirmRequest {
        if (!model) return null;
        return AgentActionConfirmRequest.newInstance(<AgentActionConfirmRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentActionConfirmRequest) {
        if (!obj) return;

        models.AgentActionConfirmRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentActionConfirmRequest): boolean {
        Object.setPrototypeOf(obj, AgentActionConfirmRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the pending action
     */
    action_id: string;

    /**
     * ID of the chat
     */
    chat_id: string;

    /**
     * Confirm or deny the pending action
     */
    status: models.AgentActionStatus;

    /**
     * User-submitted form data; required when status is 'confirm'
     */
    form_data: any;

}
